module.exports = __webpack_public_path__ + "static/media/From Someone Who Loves You.31de3675.jpg";